import api from 'plugin/api';

/**
 *  @description 검사성분그룹 목록 API
 */

async function inspGroupList(params) {
  const url = '/sfsh/inspection/irdnt-grp';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 검사성분그룹 등록 API
 */

async function inspGroupCreate(requestBody) {
  const url = '/sfsh/inspection/irdnt-grp';

  const response = await api.post(url, requestBody);
  return response;
}

/**
 *  @description 검사성분그룹 상세 API
 */
async function inspGroupDetail(seq) {
  const url = `/sfsh/inspection/irdnt-grp/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 검사성분그룹 수정 API
 */
async function inspGroupUpdate(seq, requestBody) {
  const url = `/sfsh/inspection/irdnt-grp/${seq}`;

  const response = await api.put(url, requestBody);
  return response;
}

/**
 *  @description 검사성분 한계기준정보 API
 */
async function inspIrdntList(params) {
  const url = '/sfsh/inspection/type/insp-irdnt';

  const response = await api.get(url, { params });
  return response;
}
export {
  inspGroupList,
  inspGroupCreate,
  inspGroupDetail,
  inspGroupUpdate,
  inspIrdntList
};
